export const getRankData = (state) => {
  // 1. 计算加权总分
  const competence = (state.tech + state.industry + state.stability + state.self) * 0.4;
  const politics = ((state.rels?.boss || 50) + (state.rels?.team || 50) + state.publicOpinion) * 0.1; // 简化权重
  const wealth = (state.money / 2000); 
  const seniority = state.round * 1.5;

  const score = competence + politics + wealth + seniority;
  console.log(score)
  // 2. 映射到职级
  if (score < 90) return { title: "外包数据标注员", color: "#9e9e9e" };
  if (score < 120) return { title: "初级搬砖工", color: "#4caf50" };
  if (score < 130) return { title: "核心代码搬运工", color: "#2196f3" };
  if (score < 140) return { title: "AI 基建负责人", color: "#ff9800" };
  if (score < 150) return { title: "大模型忽悠官 (CPO)", color: "#e91e63" };
  return { title: "赛博飞升者", color: "#ffd700" };
};